const module = { name: 'shared/utils/rottenTomatoesRating', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context_movieDetails_reviews } from 'require-core';

const { context: { device: { isMobile }, featureFlags }, movieDetails: { rottenTomatoesUrl } = {}, reviews = {} } = Fandango_context_movieDetails_reviews;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { fd_url_manager as links } from 'require-core';



import { Fandango_overlay as overlay } from 'base-libraries';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    CRITICS_HEADER: '.js-movie-detail-rt-score-critics-header',
    CRITIC_SCORE: '.js-movie-detail-rt-score',
    AUDIENCE_HEADER: '.js-movie-detail-rt-score-audience-header',
    AUDIENCE_SCORE: '.js-movie-detail-rt-score-audience',
    MORE_INFO: '#rt-audience-score-more-info',
    MORE_INFO_BTN: '#rt-more-info-btn',
    MOVIE_VIDEO_RT_SCORE: '.js-movie-video-rt-score'
}


const Styles = {
    MORE_INFO_OVERLAY_CLOSE_BTN: 'rotten-tomatoes__more-info-close-btn',
    MORE_INFO_OVERLAY_CONTAINER: 'rotten-tomatoes__more-info-container'
}


const URLHashes = {
    AUDIENCE_SECTION: '#audience-reviews-list',
    CRITICS_SECTION: '#critic-reviews-list',
}


const DataAttribs = {
    ID: 'id',
    LARGE_VIDEO_FLAG: 'large-video',
}


const ReviewsTypes = {
    CRITIC: 'critic',
    MOVIE: 'movie',
}


let largeVideo = false
function updateUI(isCriticScore, data) {
    if (reviews.isMobileReviews) {
        return;
    }
    const iconContainer = document.querySelectorAll(isCriticScore ? Selectors.CRITIC_SCORE : Selectors.AUDIENCE_SCORE);
    if (!iconContainer?.length) {
        return;
    }
    if (!data) {
        return;
    }
    const rtRating = isCriticScore ? data.criticsRating : data.audienceRating;
    const rtScore = isCriticScore ? data.criticsScore : data.audienceScore;
    if ((!rtScore && rtScore !== 0) || !rtRating) {
        return;
    }
    const viewModel = {
        certifiedFresh: data.certifiedFresh,
        largeVideo,
        isCriticScore,
        rottenTomatoesUrl,
        rtRating,
        rtRatingScreenReader: rtRating.replace(/_/, ' '),
        rtScore,
        rottenTomatoesEnabled: featureFlags.rottenTomatoesEnabled
    };
    iconContainer.forEach(item => item.innerHTML = swig.render('_rottenTomatoesRating', viewModel));
}
function onAudienceScoreClick(e) {
    e.preventDefault();
    track(EventTypes.AUDIENCE_SCORE);
    location.href = URLHashes.AUDIENCE_SECTION;
}
function onTomatometerClick(e) {
    e.preventDefault();
    track(EventTypes.TOMATOMETER);
    location.href = URLHashes.CRITICS_SECTION;
}
function onMoreInfoClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const markup = swig.render('_audienceScoreMoreInfo', {
        moreInfoURI: reviews.moreInfoURI,
        rottenTomatoesEnabled: featureFlags.rottenTomatoesEnabled,
    });
    overlay.open(markup, {
        overlayStyle: Styles.MORE_INFO_OVERLAY_CONTAINER,
        closeBtnStyle: Styles.MORE_INFO_OVERLAY_CLOSE_BTN,
        closeBtnParent: Selectors.MORE_INFO
    });
}
function attachEventHandlers() {
    $(Selectors.AUDIENCE_HEADER).on('click', onAudienceScoreClick);
    $(Selectors.CRITICS_HEADER).on('click', onTomatometerClick);
    $(Selectors.MORE_INFO_BTN).on('click', onMoreInfoClick);
}
function onDone(data) {
    data = data && data.data;
    updateUI(true, data);
    updateUI(false, data);
    if (data) {
        attachEventHandlers();
    }
}
function onFail() {
    updateUI(true);
    updateUI(false);
}
function attach() {
    if (!featureFlags.rottenTomatoesIntlEnabled) {
        return;
    }
    const movieId = $(Selectors.CRITIC_SCORE).data(DataAttribs.ID);
    if (!movieId) {
        return;
    }
    largeVideo = Boolean($(Selectors.MOVIE_VIDEO_RT_SCORE).data(DataAttribs.LARGE_VIDEO_FLAG));
    xhr.ajax({
        method: 'GET',
        url: links.napiFanAndCriticRatings({ id: movieId }),
    }).done(onDone).fail(onFail);
}
module.exports = {
    attach
};
export default module.exports;